//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import isEmpty from 'lodash.isempty'
import { mapGetters } from 'vuex'

import { chunk } from '@core/helpers'
import { hasSearchPaymentAdvertising } from '@payment'
import { buildResultsFromAttributes } from '@product/components/ProductThumb'
import { RecommendationProduct } from '@recommendation/RecommendationProduct'
import { setRecommendationDebugExtension } from '@recommendation/helpers'
import recommendationAPI from '@recommendation/recommendationAPI'
import { ROUTES } from '@router'
import {
  EVENT_TYPE,
  PRODUCT_DEAL_TYPE,
  PRODUCT_PROVIDERS,
  PRODUCT_SOURCE,
  PRODUCT_SOURCE_TYPE,
} from '@tracking'
import {
  trackLandingPage,
  trackProductClick,
  trackProductsImpression,
  trackSearchAnalytics,
} from '@tracking/events'

import SearchParams from '../../utils/SearchParams'
import NoResultsCard from '../NoResults/Card'

import CardsList from './CardsList'
import translations from './ProductResults.translations'
import { LANDING_TYPES } from './constants'

const NUMBER_OF_RECOMMENDATIONS = 4
const OFFSET = 1
const CHUNK_SIZE = 5

function searchResultToProduct(searchResult, hasCarrier, linkToUse, month) {
  return {
    ...searchResult,

    carriers: {
      list: searchResult.compatible_carriers,
      locked: searchResult.is_sim_locked,
      hasCarrier,
    },
    grade: searchResult.backbox_grade_label,
    isRecommendation: false,
    isVanishing: searchResult.isVanishingDeal,
    link: searchResult[linkToUse],
    name: searchResult.thumbName,
    objectID: searchResult.objectID,
    originalPrice: {
      raw: searchResult.price_new,
      display: searchResult.price_new_with_currency,
    },
    price: {
      raw: searchResult.price,
      display: searchResult.price_with_currency,
    },
    productId: searchResult.backmarketID,
    sourceType: PRODUCT_SOURCE_TYPE.RESULTS,
    subTitleModel: searchResult.sub_title_elements,
    thumbnail: searchResult.image1,
    titleModel: searchResult.title_model,
    warranty: `${searchResult.warranty} ${month}`,
  }
}

export default {
  components: {
    CardsList,
    NoResultsCard,
  },
  data() {
    return {
      isRecommendationLoading: true,
      recommendationProducts:
        this.$route.name === ROUTES.LANDING.PRODUCT
          ? Array(NUMBER_OF_RECOMMENDATIONS).fill({
              isLoading: true,
              thumbnail: 'placeholder',
            })
          : [],
      recommendationWidgetId: '',
      recommendationId: null,
    }
  },
  async fetch() {
    if (this.isProductLanding) {
      const adapter = (item) =>
        RecommendationProduct.fromAPI(item, {
          hasCarrier: this.hasCarrierFacet,
          attributesRules: this.listViewStructure.table,
          titleRules: this.listViewStructure.title,
          sourceType: PRODUCT_SOURCE_TYPE.LP_RECOS,
        })
      const requester = (request) =>
        this.$store.dispatch('http/request', request)
      const apiClient = recommendationAPI(requester, adapter)
      try {
        this.isRecommendationLoading = true

        const { widgetId, recommendationId, products } = this.useNewUrl
          ? await apiClient.getRecommendationByFilter({
              numberOffers: NUMBER_OF_RECOMMENDATIONS,
              blockType: '',
              pageType: 'landing',
              pageId: this.$route.params.uuid,
            })
          : await apiClient.getRecommendationByFilter({
              numberOffers: NUMBER_OF_RECOMMENDATIONS,
              blockType: '',
              pageType: 'landing',
              slug: this.$route.params.category,
            })

        this.recommendationId = recommendationId
        this.recommendationWidgetId = widgetId
        this.recommendationProducts = products
      } catch {
        this.recommendationProducts = []
      }
    }
    this.isRecommendationLoading = false
  },
  computed: {
    translations() {
      return translations
    },

    ...mapGetters({
      buyingGuide: 'landing/buyingGuide',
      country: 'config/country',
      filterWhitelist: 'landingSearch/filterWhitelist',
      hasCarrierFacet: 'landingSearch/hasCarrierFacet',
      isListView: 'landing/isListView',
      isVanishingDeals: 'landing/isVanishingDeals',
      landingHeroTracking: 'landing/heroTracking',
      landingType: 'landing/type',
      listViewStructure: 'landing/listViewStructure',
      paymentMethods: 'countryConfig/paymentMethods',
      searchQueryID: 'landingSearch/queryID',
      searchResultsData: 'landingSearch/results',
      sortDefaultValue: 'landingSearch/sortDefaultValue',
      visitorId: 'config/visitorId',
    }),

    showFAQ() {
      return this.searchResults?.length >= 30
    },

    showBuyingGuide() {
      return (
        this.searchResults?.length >= 5 &&
        this.buyingGuide &&
        Object.entries(this.buyingGuide).length > 0
      )
    },

    showPaymentMethodAdvertising() {
      return (
        this.searchResults?.length >= 5 &&
        this.paymentMethods &&
        hasSearchPaymentAdvertising(this.paymentMethods)
      )
    },

    showVanishingDeal() {
      return this.isVanishingDeals && this.isProductLanding
    },

    showRecommendationProducts() {
      const {
        $route: { query, hash },
        filterWhitelist: paramsWhitelist,
      } = this
      const searchParams = new SearchParams({
        query,
        hash,
        paramsWhitelist,
      })

      return !searchParams.hasUserFilters()
    },

    isProductLanding() {
      return this.$route.name === ROUTES.LANDING.PRODUCT
    },

    useNewUrl() {
      return this.$config.FF_NEW_URL_FORMAT.includes(this.country)
    },

    isListViewDisplay() {
      return this.isListView && this.isProductLanding
    },

    linkToUse() {
      if (this.landingType === LANDING_TYPES.MERCHANT) {
        return 'merchant_link_grade_v2'
      }

      return 'link_grade_v2'
    },

    searchParams() {
      return new SearchParams({
        query: this.$route.query,
        hash: this.$route.hash,
        paramsWhitelist: this.filterWhitelist,
      })
    },

    hasHero() {
      return !!this.landingHeroTracking?.id
    },

    trackingData() {
      const allResultsTrackingData = this.recommendationProducts
        .filter((product) => product && !product.isLoading)
        .concat(this.searchResults)
        .map((product, index) => {
          const position = index + OFFSET + (this.hasHero ? 1 : 0)

          const dealType =
            this.showVanishingDeal || product.isVanishing
              ? PRODUCT_DEAL_TYPE.VANISHING_DEAL
              : PRODUCT_DEAL_TYPE.NORMAL

          if (product.isRecommendation) {
            return {
              widgetId: this.recommendationWidgetId,
              list: product.sourceType,
              product: RecommendationProduct.toTrackingData(product, {
                position,
                dealType,
                source: PRODUCT_SOURCE.RECOMMENDATIONS,
                provider: PRODUCT_PROVIDERS.EARLYBIRD,
              }),
            }
          }

          return {
            list: product.sourceType,
            product: {
              brand: product.brand,
              category: product.category,
              name: product.name || product.title,
              id: product.backmarketID,
              // TODO: URL-352 Use product.id when available in Algolia to get the UUID
              uuid: product.link?.params.uuid,
              price: product.price?.raw,
              list: product.sourceType,
              position,
              variant: product.backbox_grade_value,
              merchantId: product.merchant_id,
              listingId: product.objectID,
              dealType,
              source: PRODUCT_SOURCE.SEARCH,
              provider: PRODUCT_PROVIDERS.ALGOLIA,
            },
          }
        })

      if (this.hasHero) {
        return [
          { product: this.landingHeroTracking },
          ...allResultsTrackingData,
        ]
      }

      return allResultsTrackingData
    },

    trackingProducts() {
      return this.trackingData.map((result) => result.product)
    },

    chunksTrackingProducts() {
      return chunk(this.trackingProducts, CHUNK_SIZE)
    },

    searchResults() {
      return buildResultsFromAttributes({
        attributes: this.searchResultsData,
        structure: this.listViewStructure,
      }).map((searchResult) =>
        searchResultToProduct(
          searchResult,
          this.hasCarrierFacet,
          this.linkToUse,
          this.$t(this.translations.months),
        ),
      )
    },
  },
  watch: {
    isRecommendationLoading(newVal) {
      if (!newVal) {
        trackLandingPage({
          type: this.landingType,
        })

        setRecommendationDebugExtension(this.recommendationId)

        if (!isEmpty(this.trackingProducts)) {
          this.chunksTrackingProducts.forEach((trackingArray) => {
            trackProductsImpression(trackingArray)
          })
        }
      }
    },
  },
  methods: {
    clickOnProductThumb(product, index) {
      const { productId, isRecommendation, objectID } = product
      if (!isRecommendation) {
        trackSearchAnalytics({
          type: EVENT_TYPE.CLICK,
          objectId: objectID,
          searchQueryID: this.searchQueryID,
          tokenId: this.visitorId,
          position: index + OFFSET,
          index: this.sortDefaultValue,
        })
      }

      const trackingDataProduct = this.trackingData.find(
        (track) => track.product.id === productId,
      )

      if (!isEmpty(trackingDataProduct)) {
        trackProductClick(trackingDataProduct)
      }
    },
  },
}
